import React from 'react';

const MasterEffectsPanel = ({ setMacro }) => {
    const [atmosphere, setAtmosphere] = React.useState(0);
    const [grit, setGrit] = React.useState(0);
    const [warmth, setWarmth] = React.useState(0);

    const handleAtmosphere = (e) => {
        const val = parseInt(e.target.value, 10);
        setAtmosphere(val);
        if (setMacro) setMacro('atmosphere', val / 100);
    };

    const handleGrit = (e) => {
        const val = parseInt(e.target.value, 10);
        setGrit(val);
        if (setMacro) setMacro('grit', val / 100);
    };

    const handleWarmth = (e) => {
        const val = parseInt(e.target.value, 10);
        setWarmth(val);
        if (setMacro) setMacro('warmth', val / 100);
    };

    const sliderStyle = {
        width: '100%',
        cursor: 'pointer'
    };

    const labelStyle = {
        fontSize: '0.7rem',
        color: '#888',
        marginBottom: '4px',
        display: 'block'
    };

    const containerStyle = {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        padding: '0 5px'
    };

    return (
        <div className="master-effects-panel" style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '10px',
            padding: '10px',
            backgroundColor: '#1a1a1a',
            border: '1px solid #333',
            borderRadius: '4px',
            width: '100%'
        }}>
            <h4 style={{ margin: '0 0 5px 0', fontSize: '0.8rem', color: '#888', textTransform: 'uppercase', letterSpacing: '0.1em' }}>Global Macros</h4>
            <div style={{ display: 'flex', justifyContent: 'space-between', gap: '10px' }}>

                {/* Atmosphere Slider */}
                <div style={containerStyle}>
                    <label style={labelStyle}>ATMOSPHERE</label>
                    <input
                        type="range"
                        min="0" max="100"
                        value={atmosphere}
                        onChange={handleAtmosphere}
                        style={sliderStyle}
                    />
                </div>

                {/* Grit Slider */}
                <div style={containerStyle}>
                    <label style={labelStyle}>GRIT</label>
                    <input
                        type="range"
                        min="0" max="100"
                        value={grit}
                        onChange={handleGrit}
                        style={sliderStyle}
                    />
                </div>

                {/* Warmth Slider */}
                <div style={containerStyle}>
                    <label style={labelStyle}>WARMTH</label>
                    <input
                        type="range"
                        min="0" max="100"
                        value={warmth}
                        onChange={handleWarmth}
                        style={sliderStyle}
                    />
                </div>

            </div>
        </div>
    );
};

export default MasterEffectsPanel;
